export type SocialKey = 'instagram' | 'youtube' | 'line';

/**
 * サイト共通のSNSリンク定義
 *
 * 目的:
 * - Hero / Footer などで使うSNSリンクを1箇所で管理する
 * - デプロイ環境では環境変数（NEXT_PUBLIC_SOCIAL_*）で上書きできるようにする
 *
 * 設定方法:
 * - 推奨: 環境変数 `NEXT_PUBLIC_SOCIAL_INSTAGRAM` などを設定
 * - もしくは下記 `SOCIAL_LINK_DEFAULTS` を直接編集
 */
export const SOCIAL_LINK_DEFAULTS: Record<SocialKey, string> = {
  instagram:
    'https://www.instagram.com/yuikai_woman?igsh=bjg0OWpueTRlZnl3&utm_source=qr',
  youtube: 'https://youtube.com/@yuikai-office?si=Q6wELDkwfP73Qu5Y',
  line: 'https://lin.ee/zFn6r7m',
};

const SOCIAL_ENV: Record<SocialKey, string | undefined> = {
  instagram: process.env.NEXT_PUBLIC_SOCIAL_INSTAGRAM,
  youtube: process.env.NEXT_PUBLIC_SOCIAL_YOUTUBE,
  line: process.env.NEXT_PUBLIC_SOCIAL_LINE,
};

export type SocialLink = {
  key: SocialKey;
  label: string;
  href: string;
  iconSrc: string;
};

/**
 * SNSのURLを解決する（env優先、未設定は'#'）
 *
 * 目的:
 * - 未設定でもUIが壊れない（リンク無し扱い）ようにする
 *
 * 引数:
 * - key: SNS種別
 *
 * 戻り値:
 * - URL（未設定なら '#')
 */
export function resolveSocialHref(key: SocialKey): string {
  const env = SOCIAL_ENV[key];
  const def = SOCIAL_LINK_DEFAULTS[key];
  const v = (env ?? def ?? '').trim();
  return v ? v : '#';
}

/**
 * サイト共通のSNSリンク一覧（表示用）
 *
 * 目的:
 * - UI側はこの配列をmapするだけでSNSリンクを表示できるようにする
 *
 * 戻り値:
 * - SocialLink[]
 */
export function getSocialLinks(): SocialLink[] {
  return [
    {
      key: 'instagram',
      label: 'Instagram',
      href: resolveSocialHref('instagram'),
      iconSrc: '/assets/svg/icon-instagram.svg',
    },
    {
      key: 'youtube',
      label: 'YouTube',
      href: resolveSocialHref('youtube'),
      iconSrc: '/assets/svg/icon-youtube.svg',
    },
    {
      key: 'line',
      label: 'LINE',
      href: resolveSocialHref('line'),
      iconSrc: '/assets/svg/icon-line.svg',
    },
  ];
}
